import * as React from 'react';
import Link from '@mui/material/Link';
import { Taxonomy } from '../../types/index'
import {Tab,Tabs, Box, Typography, Toolbar }from '@mui/material';

type RepeatTaxonomy = {
  childTaxonomies: RepeatTaxonomy[] | null
}

type TaxonomyTree = {
  name: string
  taxonomies: RepeatTaxonomy[]
}

export default function SearchQueryTabs(props: {
  taxonomies: Readonly<Taxonomy[]>
}) {

  const [tabValue, setTabValue] = React.useState(0)

  const [taxonomyTree, setTaxonomyTree] = React.useState([] as TaxonomyTree[])


  React.useEffect(() => {
    //TODO: 階層構造の型当ては大変なので今回はべたうちする。
    // 'category', 'post_tag', 'situation', 'other', 'series', 'nav_menu'のうち'category', 'post_tag', 'nav_menu'は除外
    const taxonomyNameList = Array.from(new Set(props.taxonomies.map(taxonomy => taxonomy.taxonomy)))
    .filter(taxonomy => !['post_tag', 'nav_menu'].includes(taxonomy))
    const getTaxonomyTree = (name: string, targetId: number): {
      parentTaxonomy: Taxonomy,
      childTaxonomies: RepeatTaxonomy[]
     }[] => {
      const taxonomies = props.taxonomies.filter(taxonomy => taxonomy.parent === targetId && taxonomy.taxonomy === name)
      if (taxonomies.length < 1) return null
      return taxonomies.map(taxonomy => {
          const data = getTaxonomyTree(name, taxonomy.term_taxonomy_id)
          return {
            parentTaxonomy: taxonomy,
            childTaxonomies: data
          }
        })
    }
    const taxonomyTree = taxonomyNameList.map(taxonomyName => ({
        name: taxonomyName,
        taxonomies: getTaxonomyTree(taxonomyName, 0)
    }))
    setTaxonomyTree(taxonomyTree)
  })

  const handleChange = (event: React.SyntheticEvent, value: number) => setTabValue(value)

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <React.Fragment>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Item One" {...a11yProps(0)} />
          <Tab label="Item Two" {...a11yProps(1)} />
          <Tab label="Item Three" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={tabValue} index={0}>
        Item One
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        Item Two
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        Item Three
      </TabPanel>
    </React.Fragment>
  );
}


const TabPanel = (props) => {
  const { children, value, index, ...other } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}